export const initTabs = () => {

    if (!$('[data-tab-nav]')) return;

    $(document).on('click', '[data-tab-nav]', function(e) {
        e.preventDefault();

        const $this = $(this);
        const id = $(this).data('tab-nav');

        const parentTabs = $this.closest('[data-tabs]');
        const currentTabNav = parentTabs.find(`[data-tab-nav="${id}"]`);
        const currentTab = parentTabs.find(`[data-tab="${id}"]`);

        parentTabs.find('[data-tab], [data-tab-nav]').removeClass('active');

        currentTabNav.addClass('active');
        currentTab.addClass('active');
    });
}
